// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__UdU-a","title":"Header_title__3Nmpu","left":"Header_left__2wyGV","clinicName":"Header_clinicName__xrEDZ"};